import { getReferrerDomain } from "./booking/booking-util"

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0
      const v = c === "x" ? r : ((r & 0x3) | 0x8)
      return v.toString(16)
    })
}

const id = uuidv4()

const analyticsUrl = process.env.GATSBY_ANALYTICS_URL!

type Message = {
  id: string;
  action: string;
  name?: string;
  hotel_url?: string;
  location?: string;
  slug: string;
  showPrice?: boolean;
  accoType?: string;
  activeGroup?: number;
  ref?: string;
}

const postMessage = (message: Message) => {

  if (typeof navigator !== `undefined`) {
    if (navigator.userAgent.toLowerCase().indexOf("bot") !== -1) {
      return
    }
  }

  message.ref = getReferrerDomain()

  typeof window !== `undefined` && (() => {
    const xhr = new XMLHttpRequest()
    xhr.open("POST", analyticsUrl, true)
    xhr.send(JSON.stringify(message))
  })()

}

const postAccoMessage = (action: any, slug: string, acco: any) => {
  const { name, hotel_url, location } = acco
  postMessage({
    id,
    action,
    name,
    hotel_url,
    location,
    slug,
  })
}

export const postTourView = (slug: string, accoType: any, showPrice: boolean, activeGroup: number) => postMessage({
  id,
  action: "tour-view",
  accoType,
  showPrice,
  activeGroup,
  slug,
})


export const postAccoView = (slug: string, acco: any) => postAccoMessage("acco-view", slug, acco)


export const postBookingLinkClick = (slug: string, acco: any) => postAccoMessage("acco-booking-call", slug, acco)

